module.exports = __webpack_public_path__ + "static/media/google.c83cd09b.svg";